<template>
    <div>
        <page-title heading="Detail Komisi User" :breadcrumb="[
          {
            label: 'Laporan Komisi',
            link: '/komisi/report',
          },
          {
            label: 'Detail',
            active: true,
          },
        ]" />
        <div class="container-fluid">
            <div class="card card-box mb-3 ninja-shadow">
                <div class="card-body">
                    <div class="row mb-5">
                        <div class="col-md-4">
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label">Nama user</label>
                                <div class="col-sm-8">
                                    <input type="text" readonly class="form-control" :value="user.name">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label">Jenis user</label>
                                <div class="col-sm-8">
                                    <input type="text" readonly class="form-control" :value="user.role">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 no-padding">
                            <DataTableWrapper :perPage="perPage" :fromPage="fromPage" :toPage="toPage"
                                :totalEntries="totalEntries" :currentPage="currentPage" :callbackFunc="fetchDetailReport"
                                :customEntryOptions="{ f: [5] }" :dropdownSizeProps="'sm'"
                                @valueChanged="handleValueChanged">
                                <template v-slot:right-header>
                                    <div class="total-comission-badge">
                                        <span class="total-comission-lb">Total Komisi</span>
                                        <span class="total-comission-val">{{ totalCommission }} ,-</span>
                                    </div>
                                </template>
                                <div
                                    id="detail-report-table"
                                    style="min-height: 280px; overflow-x: scroll; overflow-y: hidden;"
                                >
                                    <b-table :items="detailReportList" style=" width: 135%;" :fields="fieldList" thead-tr-class="izd-datatable"
                                        :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :no-local-sorting="true">
                                        <template v-slot:head()="data">
                                            {{ data.label }}
                                            <!-- <div class="row" style="min-height: 40px;">
                                                <div class="col-12 align-self-center">
                                                    {{ data.label }}
                                                </div>
                                            </div> -->
                                            <b-input size="sm" class="mt-2 w-95" v-if="data.field.searchable"
                                                @input="searchValueChanged($event, data.field.key)" />
                                        </template>
                                        <template v-slot:head(date_range)="data">
                                            {{ data.label }}
                                            <!-- <div class="row" style="min-height: 40px;">
                                                <div class="col-12 align-self-center">
                                                    {{ data.label }}
                                                </div>
                                            </div> -->
                                            <date-picker
                                                v-model="dateRange"
                                                type="date"
                                                range
                                                format="DD-MM-YYYY"
                                                value-type="YYYY-MM-DD"
                                                placeholder="DD-MM-YYYY"
                                                :style="'width: 100%; margin-top: 8px;'"
                                                @input="searchValueChanged($event, data.field.key)"
                                            >
                                            </date-picker>
                                        </template>
                                        <template v-slot:head(service)="data">
                                            {{ data.label }}
                                            <!-- <div class="row" style="min-height: 40px;">
                                                <div class="col-12 align-self-center">
                                                    NAMA<br/>LAYANAN/OBAT/BHP
                                                </div>
                                            </div> -->
                                            <div id="service-opt">
                                            <multiselect v-model="serviceTypeId" open-direction="bottom" :options="serviceTypeOpt"
                                                group-values="libs" group-label="layanan" :group-select="true"
                                                placeholder="Nama Layanan"
                                                @input="searchValueChanged($event, data.field.key)" :show-labels="false"
                                                class="__multi-select-tarif" track-by="name" label="name"><span
                                                    slot="noResult">Oops! No elements found. Consider changing the search
                                                    query.</span>
                                                <template slot="option" slot-scope="props">
                                                    <span style="padding-left: 10px;" v-if="props.option.$isLabel">{{
                                                    props.option.$groupLabel }}</span>
                                                    <span style="padding-left: 30px;" v-else>{{ props.option.name }}</span>
                                                </template>
                                                <template slot="singleLabel" slot-scope="props">
                                                    {{ props.option.name.slice(0, 18) + `${props.option.name.length > 18 ? '...' : '' }`  }}
                                                </template> 
                                            </multiselect>
                                            </div>
                                        </template>
                                        <template v-slot:head(commission_type)="data">
                                            {{ data.label }}
                                            <!-- <div class="row" style="min-height: 40px;">
                                                <div class="col-12 align-self-center">
                                                    {{ data.label }}
                                                </div>
                                            </div> -->
                                            <vue-select-clearable id="commissionTypeOpt" style="font-size: 13px"
                                                :options="commissionTypeOpt" v-model="commissionTypeId"
                                                @input="searchValueChanged($event, data.field.key)"
                                                class="custom-v-select-manajemen-tarif mt-2" placeholder="Tipe Komisi">
                                            </vue-select-clearable>
                                        </template>
                                        <template v-slot:head(price)="data">
                                            {{ data.label }}
                                            <!-- <div class="row" style="min-height: 40px;">
                                                <div class="col-12 align-self-center">
                                                    {{data.label}}
                                                </div>
                                            </div> -->
                                        </template>
                                        <template v-slot:head(commission_value)="data">
                                            {{ data.label }}
                                            <!-- <div class="row" style="min-height: 40px;">
                                                <div class="col-12 align-self-center">
                                                    {{data.label}}
                                                </div>
                                            </div> -->
                                        </template>
                                        <template v-slot:head(commission_final)="data">
                                            {{ data.label }}
                                            <!-- <div class="row" style="min-height: 40px;">
                                                <div class="col-12 align-self-center">
                                                {{data.label}}
                                                </div>
                                            </div> -->
                                        </template>
                                        <template v-slot:cell(invoice_number)="data">
                                            <router-link :to="{
                                                    name: data.item.is_penjualan ? 'penjualan-struk' : 'klinik-pembayaran-struk',
                                                    params: {
                                                        pembayaran_id: data.item.pembayaran_id,
                                                        id: data.item.pembayaran_id,
                                                    }
                                                }" 
                                                style="cursor: pointer" target="_blank">{{ data.item.invoice_number }}</router-link>
                                        </template>
                                    </b-table>
                                </div>
                            </DataTableWrapper>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
moment.locale("id");

import debounce from "lodash/debounce";
import accounting from "accounting";

moment.locale("id");
import Multiselect from "vue-multiselect";

export default {
    components: {
        Multiselect,
        DatePicker,
        DataTableWrapper: () => import("../../components/DataTableWrapper"),
        "vue-select-clearable": () => import("@/components/VueSelectClearable.vue"),
    },
    data() {
        return {
            user: {},
            userIdParam: this.$route.params.user_id || 1394,
            roleParam: this.$route.params.role_id || 1,
            dateRange: [
                this.$route.query.start_date || moment().startOf('month').format("YYYY-MM-DD"), 
                this.$route.query.end_date || moment(new Date()).format("YYYY-MM-DD")
            ],
            commissionTypeId: "",
            serviceTypeId: "",
            totalCommission: this.changeToIdr(0),
            serviceTypeOpt: [],
            commissionTypeOpt: [
                {
                    label: "%",
                    value: "persen",
                },
                {
                    label: "Rp",
                    value: "rupiah",
                },
            ],
            detailReportList: [],
            sortBy: "",
            sortDesc: false,
            currentPage: 1,
            rows: 0,
            fromPage: 0,
            toPage: 0,
            perPage: 10,
            searchValue: [
                {
                    key: "date_range",
                    value: [
                        this.$route.query.start_date || moment().startOf('month').format("YYYY-MM-DD"), 
                        this.$route.query.end_date || moment(new Date()).format("YYYY-MM-DD")
                    ]
                }
            ],
            totalEntries: 0,
            firstLoad: false
        };
    },
    computed: {
        ...mapGetters(["getKlinikId"]),
        fieldList() {
            const { generateFieldList: g, setSearchableAndSortableFieldList: s } = this;
            const r = (val) => Boolean(/(no|actions)\b/gi.test(val) ? !1 : 1);
            return (
                [
                    {
                        key: "invoice_number",
                        label: "no. invoice",
                        thStyle: "width: 200px",
                    },
                    {
                        key: "date_range",
                        label: "hari/tanggal",
                        thStyle: "width: 300px",
                    },
                    {
                        key: "service",
                        label: "nama layanan/obat/bhp",
                        thStyle: "width: 300px",
                    },
                    {
                        key: "price",
                        label: "harga",
                        thStyle: "width: 200px",
                    },
                    {
                        key: "commission_type",
                        label: "tipe komisi",
                        thStyle: "width: 180px",
                    },
                    {
                        key: "commission_value",
                        label: "nilai komisi",
                        thStyle: "width: 200px",
                    },
                    {
                        key: "commission_final",
                        label: "komisi",
                        thStyle: "width: 200px",
                    }
                ]
                |> ((v) =>
                    s({
                        field: v,
                        customFunc: r,
                    }))
                |> ((z) =>
                    g({
                        field: z,
                    }))
            );
        },
    },
    mounted() {
        this.getServiceList();
    },
    watch: {
        currentPage() {
            this.fetchDetailReport();
        },
        perPage() {
            this.fetchDetailReport();
        },
        sortBy() {
            this.fetchDetailReport();
        },
        sortDesc() {
            this.fetchDetailReport();
        },
        searchValue: {
            handler: "fetchDetailReport",
            deep: true,
        },
    },
    methods: {
        changeToIdr(value) {
            return accounting.formatColumn([value], "Rp. ", 0, ".")[0]
        },
        determineParameter() {
            const { searchValue, sortBy, sortDesc } = this;
            let v = "";
            searchValue.map((item) => {
                const x = item.key;
                v += `&${x}=${item.value}`;
            });
            if (sortBy) {
                v += `&column=${sortBy}&order=${sortDesc ? "desc" : "asc"}`;
            }
            return v;
        },
        handleValueChanged({ perPage, currentPage }) {
            perPage && (perPage |> ((_) => (this.perPage = _)));
            currentPage && (currentPage |> ((_) => (this.currentPage = _)));
        },
        searchValueChanged: debounce(function (val, key) {
            const { searchValue } = this;
            if (["service", "commission_type"].includes(key)) {
                val = val == null || val == undefined ? "" : val.value;
            }

            const z = searchValue.filter((item) => item.key !== key);
            this.searchValue = [
                ...z,
                {
                    key,
                    value: val,
                },
            ];
        }, 500),
        async getServiceList() {
            const response = await this.$axios.get(
                `klinik/list-layanan?klinik_id=${this.getKlinikId}`
            );
            let serviceList = response.data.data;

            for (let key in serviceList) {
                this.serviceTypeOpt.push({
                    layanan: key,
                    libs: serviceList[key].map(item => ({ name: item.text, value: item.id, amount: item.price || 1000000000 }))
                })
            }
        },
        async fetchDetailReport() {
            try {
                const res = await this.$axios.get(
                    `klinik/laporan-komisi/${this.userIdParam}/detail/${this.roleParam}?limit=${this.perPage
                    }&page=${this.currentPage}${this.determineParameter()}`
                )

                const { status, data } = res.data;
                if (status) {
                    const {
                        data: tmpData,
                        total: totalEntries,
                        to: toPage,
                        from: fromPage,
                        per_page: perPage,
                    } = data.list;

                    this.firstLoad = false;

                    this.totalEntries = totalEntries || 0;
                    this.toPage = toPage || 0;
                    this.fromPage = fromPage || 0;
                    this.rows = perPage || 0;
                    this.totalCommission = this.changeToIdr(data.total_commission);
                    this.user = data.user;

                    this.detailReportList = [
                        ...tmpData.map((item, index) => {
                            let priceRaw = item.perhitungan_komisi == "post" ? item.price_discount : item.price,
                                commissionValueRaw = item.commission_value;

                            let commissionValue = item.commission_type == "persen"
                                        ? parseFloat(commissionValueRaw) + "%"
                                        : this.changeToIdr(commissionValueRaw);

                            return {
                                ...item,
                                service: item.service_name,
                                date_range: moment(item.date).format('dddd, DD MMMM YYYY'),
                                price: accounting.formatColumn([priceRaw], "Rp. ", 0, ".")[0],
                                commission_type: item.commission_type == "persen" ? "%" : "Rp",
                                commission_value: commissionValue,
                                commission_final: this.changeToIdr(item.commission_final)
                            };
                        }),
                    ];

                    return this;
                }
            } catch (err) {
                // console.log(err);
            }
        }
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style>
<style lang="css">
.v-select {
    margin-top: 8px;
}

#commissionTypeOpt .vs__dropdown-toggle{
    height: calc(1.5em + 0.5rem + 2px) !important;
    background-color: #ffffff;
}

.total-comission-badge {
    background-color: #0b6cbf;
    padding: 10px;
    border-radius: 10px;
    color: #ffffff;
}

.total-comission-val {
    background-color: #ffffff;
    color: #000000;
    padding: 4px;
    border-radius: 6px;
    margin-left: 15px;
    margin-right: 3px;
}

#service-opt .multiselect {
    font-size: 12px;
    margin-top: 8px;
    z-index: 999 !important;
}

#service-opt .multiselect__content-wrapper {
    width: 300px;
}

#service-opt .multiselect .multiselect__select {
    height: 30px;
}

#service-opt .multiselect__tags {
    height: 30px;
    min-height: 0px !important;
    font-size: 12px !important;
    padding: 3px 40px 0 8px !important;
}

#service-opt .multiselect__input, .multiselect__single {
    /* line-height: 13px; */
    font-size: 12px;
}

.mx-input {
    height: 30px !important;
    font-size: 13px;
}

/* width */
#detail-report-table::-webkit-scrollbar {
    width: 5px;
}

/* Track */
#detail-report-table::-webkit-scrollbar-track {
    box-shadow: inset 0 0 1px grey;
    border-radius: 10px;
}

/* Handle */
#detail-report-table::-webkit-scrollbar-thumb {
    background: #cdcdcd;
    border-radius: 10px;
}

/* Handle on hover */
#detail-report-table::-webkit-scrollbar-thumb:hover {
    background: #cdcdcd;
}

@media only screen and (max-width: 1550px) and (min-width: 1280px) {
    body {
      overflow-x: hidden;
    }
    ::-webkit-scrollbar {
      width: initial;
    }

    #detail-report-table {
      max-width: 100% !important;
    }
  }

  @media screen and (min-width: 1300px) {
    body {
      overflow-x: visible;
    }

    body::-webkit-scrollbar-track {
      box-shadow: inset 0 0 1px grey;
      border-radius: 10px;
    }

    body::-webkit-scrollbar-thumb {
      background: #cdcdcd;
      border-radius: 10px;
    }

    #detail-report-table {
      max-width: 100% !important;
    }
  }

  .vs__search {
    color: #adadad;
    font-weight: 700;
  }
</style>
